import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'store/hooks';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const StatusCell = React.memo((row: OrderWorkunit) => {
  const { t } = useTranslation();

  const appFiltersSelected = useSelector((state) => state.filter?.selected);
  let status = '';
  let iconColor = 'action.disabled';

  const separator = '|';

  const labels = row.label?.split(separator).filter((label) => label) || [];
  const updatedStatus = labels.length > 0 ? labels[labels.length - 1] : '';

  if (row.label && Number(appFiltersSelected?.mission_advancement_id[0]) !== 100) {
    const labelLower = updatedStatus.toLowerCase();
    if (labelLower.includes('cancelled')) {
      status = t('Cancelled');
      iconColor = 'error.main';
    } else if (labelLower.includes('deleted')) {
      status = t('DELETED');
      iconColor = 'grey.500';
    }
  }

  if (!status) {
    switch (row.mission_advancement_id) {
      case 1:
        status = t('Submitted');
        iconColor = 'info.main';
        break;
      case 2:
        status = t('DM REFUSE');
        iconColor = 'error.main';
        break;
      case 3:
        status = t('DM ACCEPTED');
        iconColor = 'warning.main';
        break;
      case 4:
        status = t('DM VALIDATE');
        iconColor = 'success.main';
        break;
      case 5:
        status = t('CLIENT REFUSE');
        iconColor = 'error.main';
        break;
      case 6:
        status = t('CLIENT ACCEPTED WITH RESERVATION');
        iconColor = 'warning.main';
        break;
      case 7:
        status = t('CLIENT ACCEPTED');
        iconColor = 'success.main';
        break;
      default:
        status = t('NOT SUBMITTED');
        iconColor = 'warning.main';
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: iconColor,
          flexShrink: 0,
        }}
      />
      <Typography variant="body2">{status}</Typography>
    </Box>
  );
});

export default StatusCell;
